/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoSelectIcono from "../../Modulo_formularios/Componentes/IngresoSelectIcono";
import {useEffect, useState} from "react";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import IngresoSelectMultipleIcono from "../../Modulo_formularios/Componentes/IngresoSelectMultipleIcono";


const Formulario_Producto_Pasarela = ({...props}) => {
    const [modelos, setModelos] = useState([])

    useEffect(() => {

        let col = props.props.getValues('idColeccion')

        if (col) {

            let w = [where('id', '==', col)]
            obtenerColWheres({col: 'colecciones', wheres: w}).then((dox) => {
                if (dox.data && dox.data[0]) {
                    let col = dox.data[0]
                    let modelos = col.imgs
                    setModelos(modelos)
                }
            })
        }

    }, [props.props.watch('coleccion')])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Relacionar Modelos</Typography>
                </Grid>


                <Grid container size={12}>
                    <IngresoSelectMultipleIcono {...props} dato={'modelos'} opciones={modelos}/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Producto_Pasarela